import { render, staticRenderFns } from "./email_participants_warning.vue?vue&type=template&id=4de5859a&vue3"
import script from "./email_participants_warning.vue?vue&type=script&lang=js&vue3"
export * from "./email_participants_warning.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports